// NPM Imports
import React, { Component, Fragment } from "react";
import { debounce } from "lodash";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Button, Input } from "../../../revvComponents";

// Components Imports
import ProductListItem from "../ProductListItem";
import CatalogSearchBar from "../CatalogSearchBar";
import { ReactSelect } from "../../../commonComponents";

// Internal Imports
import { DOCUMENTS } from "../../../constants";
import LZLoader from "../../../commonComponents/LZLoader";

// Destructuring
const { PRODUCT_CONFIG_TYPES } = DOCUMENTS;

class ProductListing extends Component {
  state = {
    productConfigType: "all",
    productType: "All Product Types",
    searchText: "",
  };

  _handleSearch = searchText => {
    this.props.onCatalogSearch(searchText, this.state.productType);
  };

  _handleSearchText = e => {
    this.setState({ searchText: e.target.value });
  };

  _onProductTypeUpdate = productType => {
    this.setState({ productType }, () =>
      this.props.onCatalogSearch(this.state.searchText, productType),
    );
  };

  _changeProductConfigType = value => {
    if (this.state.productConfigType !== value) {
      this.setState({
        productConfigType: value,
      });
    }
  };

  _getProductConfigTypeSpecificCount = configType => {
    if (configType === "all") {
      return this.props.catalogItems.length;
    }
    return this.props.catalogItems.filter(
      item => item.product.config_type === configType,
    ).length;
  };

  _isBtnActive = type =>
    this.state.productConfigType === type ? "is-active" : "";

  _filterProductCatalogItems = (catalogItems, filter) =>
    catalogItems.filter(
      item => filter === "all" || item.product.config_type === filter,
    );

  // check if all the catalog items already added to deal table
  _isAllCatalogItemsDisabled = (catalogItems, filter) => {
    const filteredCatalogItems = this._filterProductCatalogItems(
      catalogItems,
      filter,
    );
    return filteredCatalogItems.filter(item => !item.isDisabled).length === 0;
  };

  // check if all the catalog items are selected
  _isAllItemsSelected = () => {
    const catalogItems = this._filterProductCatalogItems(
      this.props.catalogItems,
      this.state.productConfigType,
    );
    if (catalogItems.length > 0) {
      return (
        this.props.catalogItems.find(
          item =>
            !item.isChecked &&
            !item.isDisabled &&
            (this.state.productConfigType === "all" ||
              item.product.config_type === this.state.productConfigType),
        ) === undefined
      );
    }
    return false;
  };

  _selectAllItems = e => {
    const isChecked = e.target.checked;
    let selectedIds = 0;
    // Update store as all items are checked
    const { catalogItems } = this.props;
    const { productConfigType } = this.state;
    if (productConfigType === "all") {
      selectedIds = catalogItems
        .filter(item => !item.isDisabled)
        .map(item => item.id);
    } else {
      selectedIds = catalogItems
        .filter(
          item =>
            item.product.config_type === productConfigType && !item.isDisabled,
        )
        .map(item => item.id);
    }
    this.props.onAllProductsSelect(selectedIds, isChecked);
  };

  _filterDataByProductConfigType = () =>
    this._filterProductCatalogItems(
      this.props.catalogItems,
      this.state.productConfigType,
    ).map(item => (
      <ProductListItem
        currencySymbol={this.props.currencySymbol}
        data={item}
        key={item.id}
        onSelect={this.props.toggleCheckboxSelection}
      />
    ));

  _clearSearchText = () => {
    this.setState({ searchText: "" });
    this._handleSearch("");
  };

  render() {
    if (this.props.loader) {
      return <LZLoader />;
    }
    const delaySearch = debounce(term => {
      this._handleSearch(term);
    }, 300);
    const { catalogItems } = this.props;
    return (
      <Fragment>
        <div className="productlisting-search-section">
          <div className="productlisting-search-bar">
            <CatalogSearchBar
              handleSearchText={this._handleSearchText}
              searchText={this.state.searchText}
              handleSearch={delaySearch}
              submitSearch={this._handleSearch}
              clearSearchText={this._clearSearchText}
            />
          </div>
          <div className="productlisting-search-filter">
            <ReactSelect
              onChange={category => this._onProductTypeUpdate(category.value)}
              options={["All product types", ...this.props.productTypes]}
              value={this.state.productType}
              data-test="productlisting-select"
            />
          </div>
        </div>
        <div className="productlisting-search-actions">
          <div className="productlisting-checkbox">
            <Input
              checked={this._isAllItemsSelected()}
              onChange={this._selectAllItems}
              disabled={this._isAllCatalogItemsDisabled(
                this.props.catalogItems,
                this.state.productConfigType,
              )}
              type="checkbox"
              value=""
              data-test="productlisting-input"
            />
          </div>
          <div className="productlisting-filter-actions">
            <Button
              onClick={() => this._changeProductConfigType("all")}
              className={`productlisting-search-actionsbtn ${this._isBtnActive(
                "all",
              )}`}
              data-test="productlisting-filter-btn">
              All ({this._getProductConfigTypeSpecificCount("all")})
            </Button>
            {PRODUCT_CONFIG_TYPES.map(productConfig => (
              <Button
                key={productConfig}
                onClick={() => this._changeProductConfigType(productConfig)}
                className={`productlisting-search-actionsbtn ${this._isBtnActive(
                  productConfig,
                )}`}
                data-test="productlisting-productconfig-btn">
                {productConfig} (
                {this._getProductConfigTypeSpecificCount(productConfig)})
              </Button>
            ))}
          </div>
        </div>
        <div className="productlisting-list-section">
          <div className="productlisting-list-scrollable">
            {catalogItems &&
              catalogItems.length > 0 &&
              this._filterDataByProductConfigType()}
          </div>
        </div>
      </Fragment>
    );
  }
}

ProductListing.propTypes = {
  // Props
  catalogItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

const mapStateToProps = state => {
  const { props: { ptype: productTypes = [] } = {} } = state.DealTableStore;

  return { productTypes };
};

export default connect(mapStateToProps, null)(ProductListing);
